import {
  POS_INV_LOADING,
  POS_INV_DASHBOARD,
  POS_INV_ITEMS,
  POS_INV_MOVEMENTS,
} from "./actionTypes";

const initialState = {
  loading: false,
  dashboard: null,
  items: [],
  page: 1,
  lastPage: 1,
  total: 0,
  movements: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_INV_LOADING:
      return { ...state, loading: action.payload };
    case POS_INV_DASHBOARD:
      return { ...state, dashboard: action.payload };
    case POS_INV_ITEMS:
      return {
        ...state,
        loading: false,
        items: action.payload.data || [],
        page: action.payload.current_page || 1,
        lastPage: action.payload.last_page || 1,
        total: action.payload.total || 0,
      };
    case POS_INV_MOVEMENTS:
      return { ...state, movements: action.payload };
    default:
      return state;
  }
}
